const coachRoutes = [
    // HOME
    {
        path: '/coach/home',
        name: 'coach.home',
        component: () => import('@/views/coach/Home'),
        meta: {
            drawer: true,
            footer: true,
        }
    },

    // STUDENTS
    {
        path: '/coach/students',
        name: 'coach.students',
        component: () => import('@/views/coach/Students'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },
    {
        path: '/coach/students/chats',
        name: 'coach.students.chats',
        component: () => import('@/views/coach/Chats'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },
    {
        path: '/coach/students/groups',
        name: 'coach.students.groups',
        component: () => import('@/views/coach/Groups'),
        meta: {
            toolbar: true,
            drawer: true,
            footer: true,
        }
    },
    {
        path: '/coach/students/:uid',
        name: 'coach.students.profile',
        component: () => import('@/views/coach/StudentProfile'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // LIBRARY
    {
        path: '/coach/library',
        name: 'coach.library',
        component: () => import('@/views/coach/Library'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // BLOCKS
    {
        path: '/coach/blocks/:uid/edit',
        name: 'coach.blocks.edit',
        component: () => import('@/views/coach/EditBlock'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },

    // ROUTINES
    {
        path: '/coach/routines',
        name: 'coach.routines',
        component: () => import('@/views/coach/Routines'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },
    {
        path: '/coach/routines/create',
        name: 'coach.routines.create',
        component: () => import('@/views/coach/CreateRoutine'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/coach/routines/:uid',
        name: 'coach.routines.detail',
        component: () => import('@/views/coach/RoutineDetail'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/coach/routines/:uid/edit',
        name: 'coach.routines.edit',
        component: () => import('@/views/coach/EditRoutine'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/coach/routines/:uid/edit/assigned',
        name: 'coach.routines.edit.assigned',
        component: () => import('@/views/coach/EditAssignedRoutine'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/coach/routines/:uid/assign',
        name: 'coach.routines.detail.assign',
        component: () => import('@/views/coach/AssignRoutine'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },

    // PROGRAMS
    {
        path: '/coach/routines/programs/:uid',
        name: 'coach.routines.program.detail',
        component: () => import('@/views/coach/ProgramDetail'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/coach/routines/programs/:uid/routine/:id',
        name: 'coach.routines.program.detail.routine',
        component: () => import('@/views/coach/ProgramRoutineDetail'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/coach/routines/programs/:uid/routine/:id/edit',
        name: 'coach.routines.program.routine.edit',
        component: () => import('@/views/coach/EditProgramRoutine'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/coach/routines/programs/:uid/assign',
        name: 'coach.routines.program.assign',
        component: () => import('@/views/coach/AssignProgram'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },

    // CALENDAR
    {
        path: '/coach/calendar',
        name: 'coach.calendar',
        component: () => import('@/views/coach/Calendar'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },
    {
        path: '/coach/calendar/:uid',
        name: 'coach.calendar.assignedRoutine',
        component: () => import('@/views/coach/AssignedRoutineDetail'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },

    // STATISTICS
    {
        path: '/coach/statistics',
        name: 'coach.statistics',
        component: () => import('@/views/coach/Statistics'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // PROFILE
    {
        path: '/coach/profile',
        name: 'coach.profile',
        component: () => import('@/views/coach/Profile'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        },
    },
    {
        path: '/coach/profile/:mode',
        name: 'coach.profile.edit',
        component: () => import('@/views/coach/EditProfile'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/coach/payment-method',
        name: 'coach.payment.edit',
        component: () => import('@/views/coach/PaymentMethod'),
        props: true,
        meta: {
            drawer: true,
            toolbar: true,
        }
    },

    // EVALUATIONS
    {
        path: '/coach/evaluations',
        name: 'coach.evaluations',
        component: () => import('@/views/coach/Evaluations'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        },
    },
    {
        path: '/coach/evaluations/list',
        name: 'coach.evaluations.list',
        component: () => import('@/views/coach/EvaluationsList'),
        meta: {
            drawer: true,
            toolbar: true,
        },
    },
    {
        path: '/coach/evaluations/statistics/:type/:id',
        name: 'coach.evaluations.statistics',
        component: () => import('@/views/coach/EvaluationsStatistics'),
        meta: {
            drawer: true,
            toolbar: true,
        },
    },

    // PAYMENT
    {
        path: '/coach/select-plan',
        name: 'coach.select-plan',
        component: () => import('@/views/coach/SelectPlan'),
    },
    {
        path: '/coach/credit-card',
        name: 'coach.credit-card',
        component: () => import('@/views/coach/CreditCard'),
    },
]

export default coachRoutes;